import { createSelector } from "reselect";
import { getHasCoachingResources } from "@microdoing/shared/services/coaching/selectors";
import { AppState } from "../rootReducer";

export const getCampaignResources = (state: AppState) =>
  state.resources.campaignResources || [];

export const getCampaignResourcesRequesting = (state: AppState) =>
  state.resources.requesting || false;

export const getHasCampaignResources = createSelector(
  getCampaignResources,
  campaignResources => campaignResources.length > 0,
);

export const getHasResources = createSelector(
  getHasCampaignResources,
  getHasCoachingResources,
  (hasCampaignResources, hasCoachingResources) => {
    return hasCampaignResources || hasCoachingResources;
  },
);
